import { Prompt } from "@models/prompt.model";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const promptsActions = createActionGroup({
    source: 'AI Insights Prompts',
    events: {
        'Load Prompts': props<{ initLoad: boolean }>(),
        'Loaded Prompts': props<{ prompts: Prompt[] }>(),
        'Add Prompt': props<{ prompt: Prompt }>(),
        'Remove Prompt': props<{ promptId: string }>(),
        'Patch Prompt': props<{ promptId: string, deltaPrompt: Partial<Prompt> }>(),
        'Error Loading Prompts': emptyProps()
    },
});
